export default {
  missingCat: 'Missing Cat',
  ifFound1: 'If found, please return',
  ifFound2: 'to the nearest cat cafe.',
  oops: 'Opps! Lost in the woods!',
  error: '404 - Not Found',
  errorDetails: 'We searched high and low, but we could not find the page you were looking for.',
}
